module.exports = __webpack_public_path__ + "3dde85167abdab8907426c7c56e30c06.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/necklace-gem.png
// module id = 1324
// module chunks = 0